const PARTNERS_WITH_SERVICE_SELECTOR = ['demo'] // TODO add ILH when we have their slug

// DEPRECATED: This deprecated and will be removed when new Architecture is implemented.
export const hasServiceSelector = () => {
  const pathName = window.location.pathname
  const partnerKey = pathName.split('/')[1]

  return PARTNERS_WITH_SERVICE_SELECTOR.includes(partnerKey)
}
